import { addLocaleData } from 'react-intl';

/* eslint-disable global-require, import/no-dynamic-require, security/detect-non-literal-require */

function fallbackLocale(locale) {
  if (locale.indexOf('-') > -1) {
    return locale.split('-')[0];
  }
  return null;
}

function loadData(locale) {
  try {
    const localeData = require(`react-intl/locale-data/${locale}`);
    addLocaleData(localeData);
  } catch (e) {
    const fallback = fallbackLocale(locale);
    if (fallback) {
      loadData(fallback);
    }
  }
}

export default function translations(locale) {
  try {
    const t = require(`../../i18n/translations/translation.${locale}.yml`);
    loadData(locale);
    return t;
  } catch (e) {
    const fallback = fallbackLocale(locale);
    if (fallback) {
      return translations(fallback);
    }
    return {};
  }
}

/* eslint-enable */



// WEBPACK FOOTER //
// ./src/lib/translations.js